import { render, staticRenderFns } from "./Dialog_UpdateStudent.vue?vue&type=template&id=b9c60854&scoped=true&"
import script from "./Dialog_UpdateStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateStudent.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_UpdateStudent.vue?vue&type=style&index=0&id=b9c60854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c60854",
  null
  
)

export default component.exports